import React, { useCallback } from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Button from '../../../../../elements/Button';
import DownloadIcon from '../../../../../../resources/icons/download.svg';

function DownloadLeadsButton(props) {
    const { className = '', event } = props,
        i18n = useI18n();

    const handleDownload = useCallback(() => {
        app.api.leads.downloadFile(event.id, event.name);
    }, [event]);

    return (
        <Button className={[className, 'primary'].join(' ')} onClick={handleDownload}>
            <DownloadIcon className="marginRight" />
            {i18n['label.download']}
        </Button>
    );
}

export default DownloadLeadsButton;
